import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    userName:"",
    loginName:"",
    portalHtml:'',
    addTabStatus:false,
    addTabMenu:{},
    isShowFileTime:false
  },
  mutations: {
    createUserName(state, info) {
      state.userName = info
    },
    createPortalHtml(state, info) {
      state.portalHtml = info
    },

    changeAddTabName(state, payload) {
      state.addTabMenu = payload
    },
    changeAddTabStatus(state, status) {
      state.addTabStatus = status
    },

    //控制显示订单详情合同管理模块文件上传文件的显示
    showFileTime(state, status) {
      state.isShowFileTime = status
    },
    
  },
  getters:{
    getUserName(state) {
      return state.userName
    },
    getPortalHtml(state) {
      return state.portalHtml
    },
    
  },
  actions: {
 
  },
  modules: {
  },
})
